import Vue from "vue";
import Vuex from 'vuex';
import App from "./App.vue";
import router from "./router";
import store from "./store.js";
import axios from 'axios';
import "./registerServiceWorker";
//plugins
import NowUIKit from './plugins/now-ui-kit';
import * as VueGoogleMaps from 'vue2-google-maps';

import {RUTA_BASE} from '@/constants';

async function initializeApp() {
  var cadJson = 'json/parametros.json';
  const respuesta = await axios.get(RUTA_BASE + cadJson);
  
  store.commit('set_api_key', respuesta.data.api_key);
  store.commit('set_pago_pasarela', respuesta.data.pago_pasarela);
  store.commit('set_tipo_pasarela', respuesta.data.tipo_pasarela);
  store.commit('set_sin_dni', respuesta.data.sin_dni);
  store.commit('set_sin_cuenta_banco', respuesta.data.sin_cuenta_banco);
  store.commit('set_centro_pasarela', respuesta.data.centro_pasarela);
  store.commit('set_ruta_pasarela', respuesta.data.ruta_pasarela);
  store.commit('set_ruta_pasarela_banco', respuesta.data.ruta_pasarela_banco);
  store.commit('set_ruta_pasarela_banco_pruebas', respuesta.data.ruta_pasarela_banco_pruebas);
  store.commit('set_fecha_inicio_deshabilitada', respuesta.data.fecha_inicio_deshabilitada);
  store.commit('set_header_simple', respuesta.data.header_simple);
  store.commit('set_header_solida', respuesta.data.header_solida);
  store.commit('set_menu_color', respuesta.data.menu_color);
  store.commit('set_controlar_NIF', respuesta.data.controlar_NIF);
  store.commit('set_logo_altura', respuesta.data.logo_altura);
  store.commit('set_titulo_web', respuesta.data.titulo_web);
  store.commit('set_ruta_favicon', respuesta.data.ruta_favicon);
  store.commit('set_cliente_nombre', respuesta.data.cliente_nombre);
  store.commit('set_ruta_web_cliente', respuesta.data.ruta_web_cliente);
  store.commit('set_homepage', respuesta.data.homepage);
  store.commit('set_apellido2_obligatorio', respuesta.data.apellido2_obligatorio);
  store.commit('set_cp_obligatorio', respuesta.data.cp_obligatorio);
  store.commit('set_localidad_obligatorio', respuesta.data.localidad_obligatorio);
  store.commit('set_provincia_obligatorio', respuesta.data.provincia_obligatorio);

  // Verifica si la ruta actual es la de pagos y tiene el parámetro requerido
  if (router.currentRoute.name === 'pagos' && router.currentRoute.query.datos) {
    // No realiza ninguna redirección si ya está en la página de pagos con los datos necesarios
  } else {
    // Redirecciona a la página configurada como homepage si no está accediendo a pagos con datos
    /*
    router.push(store.state.homepage).catch(err => {
      if (!err.name === 'NavigationDuplicated') {
        throw err;
      }
    });
    */
  }

  
  Vue.use(VueGoogleMaps, {
    load: {
      key: store.state.api_key
    }
  });
}

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(NowUIKit);

// Llama a initializeApp antes de crear la instancia de Vue
initializeApp().then(() => {
  new Vue({
    store,
    router,
    render: h => h(App)
  }).$mount("#app");
});
